import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import AccountCircle from "@material-ui/icons/Search";
import * as theme from "../theme";

const height = 40;
const borderRadius = 7;
const styles = {
  root: {
    background: theme.COLORS.help_tip,
    height: height,
    borderRadius: borderRadius,
  },
  input: {
    color: "black",
    height: height,
    borderRadius: borderRadius,
    border: "0px solid red",
  },
  cssLabel: {
    color: "red",
    border: 0,
  },
};

function CustomizedInputs(props) {
  const { classes } = props;
  const ph = props.placeholder ? props.placeholder : "Ask Quotey a question...";
  return (
    <TextField
      variant="outlined"
      fullWidth
      className={classes.root}
      placeholder={ph}
      InputLabelProps={{
        className: classes.cssLabel,
      }}
      InputProps={{
        className: classes.input,
        startAdornment: (
          <InputAdornment position="start">
            <AccountCircle style={{ color: "C2C2C3" }} />
          </InputAdornment>
        ),
      }}
    />
  );
}

CustomizedInputs.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CustomizedInputs);
